if (!customElements.get('menu-drawer-new')) {
  customElements.define(
    'menu-drawer-new',
    class MenuDrawerNew extends HTMLElement {
      constructor() {
        super();
        this.drawerOpeners = document.querySelectorAll('[data-menu-drawer-open]');
        this.drawerClosers = document.querySelectorAll('[data-menu-drawer-close]');
      }

      connectedCallback() {
        this.drawerOpeners.forEach((opener) => {
          opener.addEventListener('click', this.openDrawer.bind(this));
        });

        this.drawerClosers.forEach((closer) => {
          closer.addEventListener('click', this.closeDrawer.bind(this));
        });

        this.addEventListener('click', (event) => {
          if (event.target === this) {
            this.closeDrawer();
          }
        });
      }

      openDrawer() {
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden', 'drawer-open');
      }

      closeDrawer() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden', 'drawer-open');
      }
    }
  );
}

if (!customElements.get('mobile-menu-item')) {
  customElements.define(
    'mobile-menu-item',
    class MobileMenuItem extends HTMLElement {
      constructor() {
        super();
        this.subMenuContainer = this.querySelector('[data-sub-menu-container]');
        this.subMenuOpener = this.querySelector('[data-sub-menu-opener]');
        this.subMenuBackButton = document.querySelector('[data-sub-menu-back]');
      }

      connectedCallback() {
        this.subMenuOpener.addEventListener('click', this.openSubMenu.bind(this));
        this.subMenuBackButton.addEventListener('click', this.closeSubMenu.bind(this));
      }

      openSubMenu() {
        this.subMenuOpener.setAttribute('expanded', '');
        this.subMenuBackButton.classList.remove('hidden');
      }

      closeSubMenu() {
        this.subMenuOpener.removeAttribute('expanded');
        this.subMenuBackButton.classList.add('hidden');
      }
    }
  );
}
